import React from "react"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import FieldUrl_InlineEditableView from "../components/inline-editable";

export default function FieldUrl_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <FieldUrl_InlineEditableView {...props} value={value} onChange={props.onChange}/>

}